import { init } from './core/init';
import * as logging from './logging';
import LogLevel from './constants/levels';
import * as types from './constants/types';
import { set as setDefaults } from './core/defaults';
import ChaynsLogger from './utils/ChaynsLogger';

export {
    ChaynsLogger,
};

export type {
    LogObject,
} from './types/LogObject';


export type {
    LogDto,
} from './types/LogDto';

export type {
    LogErrorObject,
} from './types/LogErrorObject';

export type {
    LoggerConfig,
} from './types/LoggerConfig';

export type {
    default as IChaynsLogger,
} from './types/IChaynsLogger';

export const levels = LogLevel;

export default {
    types,
    levels: LogLevel,
    /**
     * @deprecated Please use a ChaynsLogger instance for accessing this method
     */
    init,
    /**
     * @deprecated Please use a ChaynsLogger instance for accessing this method
     */
    setDefaults,
    /**
     * @deprecated Please use a ChaynsLogger instance for accessing this method
     */
    debug: logging.debug,
    /**
     * @deprecated Please use a ChaynsLogger instance for accessing this method
     */
    info: logging.info,
    /**
     * @deprecated Please use a ChaynsLogger instance for accessing this method
     */
    warning: logging.warning,
    /**
     * @deprecated Please use a ChaynsLogger instance for accessing this method
     */
    error: logging.error,
    /**
     * @deprecated Please use a ChaynsLogger instance for accessing this method
     */
    critical: logging.critical,
};
